"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = QuestionContainer;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _QuestionContext = require("../QuestionContext");

var _QuestionContext2 = _interopRequireDefault(_QuestionContext);

var _CardQuestionContainer = require("../CardQuestionContainer");

var _CardQuestionContainer2 = _interopRequireDefault(_CardQuestionContainer);

var _FlatQuestionContainer = require("../FlatQuestionContainer");

var _FlatQuestionContainer2 = _interopRequireDefault(_FlatQuestionContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function QuestionContainer(props) {
  const {
    containerStyleType
  } = (0, _react.useContext)(_QuestionContext2.default) || {};

  if (containerStyleType === undefined || containerStyleType === "paper") {
    return _react2.default.createElement(_CardQuestionContainer2.default, props);
  } else if (containerStyleType === "flat") {
    return _react2.default.createElement(_FlatQuestionContainer2.default, props);
  }
}